import { productDomains } from 'features/views/dashboard/todaysUrgencies/constants';

import UnpaidFirstPayment from './UnpaidFirstPayment';

export const UnpaidFirstPaymentList = () => (
	<>
		<UnpaidFirstPayment productDomain={productDomains.POV} />
		<UnpaidFirstPayment productDomain={productDomains.HAV} />
		<UnpaidFirstPayment productDomain={productDomains.SME} />
		<UnpaidFirstPayment productDomain={productDomains.ONZP} />
		<UnpaidFirstPayment productDomain={productDomains.ZP} />
	</>
);

export default UnpaidFirstPaymentList;
